import script from "./CombineOrderModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CombineOrderModal.vue?vue&type=script&setup=true&lang=ts"

import "./CombineOrderModal.vue?vue&type=style&index=0&id=22c127f0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22c127f0"]])

export default __exports__